"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const hooks_1 = require("../../shared/hooks");
const useUpdateSelectedOption_1 = require("./useUpdateSelectedOption");
const Content = styled_components_1.default.div `
  display: none;
  &[data-selected="true"]:not(:empty) {
    display: block;
  }
`;
const TabsWrapper = styled_components_1.default.div.attrs((props) => ({
    variant: props.variant || "inline",
    isMobile: props.isMobile
})) `
  width: 100%;
  margin-bottom: ${(props) => props.theme.spacings.m};
  overflow: hidden;
  position: relative;

  &:before {
    position: absolute;
    display: block;
    content: " ";
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: ${(props) => props.theme.colors.silverBase};
  }

  ${(props) => props.variant === "flex"
    ? `
    ul {
      display: flex !important;
      overflow-x: auto;
      overflow-y: hidden;
    }
    
    ul li {
       margin: 0 auto;
       
       & a {
         white-space: nowrap;
       }         
      }    
  `
    : ""}

  ${(props) => props.isMobile
    ? `
     padding-top: 0.5rem;
     margin-top: 0;
     margin-bottom: 0;
    ul li {
       padding-bottom: ${props.theme.spacings.s} !important;                        
    }    
  `
    : ""} 
 
  
  ${(props) => props.variant === "inline"
    ? `
    ul {
      grid-template-columns: repeat(auto-fit,minmax(10px,max-content)) !important;    
      grid-gap: 1rem;
    }
    ul li {       
       &:last-child {
        margin-right: 0;
       }
    }    
  `
    : ""}  
 
  ul {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(10px, 1fr));

    li {
      line-height: 150%;
      cursor: pointer;
      position: relative;
      padding-bottom: 2px;
      z-index: 2;
      top: 2px;
      &[data-selected="true"] {
        border-bottom: 2px solid
          ${(props) => props.theme.colors.greyBase};
        font-weight: 500;
        top: 0px;
      }
    }
  }

  a,
  a:active,
  a:link,
  a:visited {
    color: ${({ theme }) => theme.colors.greyBase};
    display: inline-block;
    text-align: center;
    text-decoration: none;
    padding: 0
      ${({ theme }) => `${theme.spacings.m} ${0} ${theme.spacings.m}`};

    @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
      padding: ${({ theme }) => `0 0.875rem ${theme.spacings.xxs}`};
    }
  }
`;
const Tabs = (0, react_1.memo)(({ children = [], variant, options = [], selected = 0, onChange, className }) => {
    let initialSelected = selected;
    options.forEach((option, index) => {
        option.selected && (initialSelected = index);
    });
    const [tab, setTab] = (0, react_1.useState)(initialSelected);
    // TODO: TS - This implemanation is trash, used any to resolve ts errors. Refactor later...
    const selectTab = (tabElement, idx) => {
        if (idx === tab)
            return;
        setTab(idx);
        onChange && onChange(tabElement, idx);
    };
    (0, useUpdateSelectedOption_1.useUpdateSelectedOption)(options, setTab);
    const { isMobile } = (0, hooks_1.useRWD)();
    return ((0, jsx_runtime_1.jsxs)(TabsWrapper, { variant: variant, isMobile: isMobile, className: className, children: [(0, jsx_runtime_1.jsx)("ul", { children: [...options, ...children].map((child, idx) => {
                    const label = options.length
                        ? options[idx].label
                        : child.props["data-tab"];
                    return ((0, jsx_runtime_1.jsx)("li", { "data-tab": label, "data-selected": tab === idx, onClick: () => {
                            var _a, _b;
                            if (options.length)
                                (_b = (_a = options[idx]).onSelect) === null || _b === void 0 ? void 0 : _b.call(_a, options[idx], idx);
                            selectTab(label, idx);
                        }, children: (0, jsx_runtime_1.jsx)("a", { href: options[idx].to, onClick: (e) => e.preventDefault(), "data-cy": `navigation-tab-${options[idx].label}`, children: label }, void 0) }, label));
                }) }, void 0), react_1.Children.map(children, (child, idx) => ((0, jsx_runtime_1.jsx)(Content, { "data-selected": tab === idx, children: child.props.children }, idx)))] }, void 0));
});
exports.Tabs = Tabs;
//# sourceMappingURL=tabs.js.map